// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { AddPasswordView } from "./view";

import { requiresAuth } from "../../utils/auth";
import { rootRoute } from "../root/route";

export const addPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  beforeLoad({ search }) {
    const localToken = localStorage.getItem("token");
    if (!("code" in search && "email" in search && !localToken)) {
      requiresAuth();
    }
  },
  path: "onboarding",
  component: AddPasswordView,
});
